<kiwi-decision-content class="financialContent cell-block-y" *ngIf="decision">
    <div class="cell auto grid-x">
        <div class="cell xsmall-24 xlarge-16 xxlarge-14 financialContent-item grid-y grid-margin-y">
            <form #playerFinancialDecisionForm="ngForm">
                <fieldset class="cell shrink">
                    <legend [i18nKey]="'decisions.financial.loans'"></legend>
                    <table class="_tableColor">
                        <tbody>
                        <tr class="_titlePartTable">
                            <td class="_number"[i18nKey]="'decisions.financial.previous.period.loan.amount'"></td>
                            <td class="_number"[i18nKey]="'decisions.financial.loan.amount'"></td>
                            <td class="_number"[i18nKey]="'decisions.financial.previous.period.loan.annual.percentage.rate'"></td>
                            <td class="_number"[i18nKey]="'decisions.financial.loan.annual.percentage.rate'"></td>
                            <td class="_number"[i18nKey]="'decisions.financial.relation.loan.equity'"></td>
                        </tr>

                        <tr>
                            <td class="_number">
                                {{parameters.previousPeriodLoanAmount | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
                            </td>
                            <td>
                                <kiwi-currency-input [(ngModel)]="decision.loanAmount"
                                                     [min]="decision.minLoanAmount"
                                                     [max]="decision.maxLoanAmount"
                                                     [disabled]="decisionsReadonly || !isAnimator"
                                                     (change)="onLoanAmountUpdate()"
                                                     name="loanAmount"></kiwi-currency-input>
                            </td>
                            <td class="_number">
                                {{parameters.previousPeriodLoanAnnualPercentageRate * 100 | number:'1.2'}} %
                            </td>
                            <td>
                                <kiwi-percentage-input [(ngModel)]="decision.loanAnnualPercentageRate"
                                                       [disabled]="decisionsReadonly || !isAnimator"
                                                       (change)="onValueUpdate()"
                                                       name="loanAnnualPercentageRate">
                                </kiwi-percentage-input>
                            </td>
                            <td class="_number">{{relationLoanOwnEquity | number:'1.4'}}</td>
                        </tr>
                        </tbody>
                    </table>
                </fieldset>
                <fieldset class="cell shrink">
                    <legend [i18nKey]="'decisions.financial.investments'"></legend>

                    <table class="_tableColor">
                        <tbody>
                        <tr class="_titlePartTable">
                            <td class="_number"[i18nKey]="'decisions.financial.previous.period.investment.amount'"></td>
                            <td class="_number"[i18nKey]="'decisions.financial.investment.amount'"></td>
                            <td class="_number"[i18nKey]="'decisions.financial.previous.period.investment.annual.percentage.rate'"></td>
                            <td class="_number"[i18nKey]="'decisions.financial.investment.annual.percentage.rate'"></td>
                        </tr>

                        <tr>
                            <td class="_number">
                                {{parameters.previousPeriodInvestmentAmount | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
                            </td>
                            <td>
                                <kiwi-currency-input [(ngModel)]="decision.investmentAmount"
                                                     [min]="decision.minLoanAmount"
                                                     [max]="decision.maxLoanAmount"
                                                     [disabled]="decisionsReadonly"
                                                     (change)="onValueUpdate()"
                                                     name="investmentAmount"></kiwi-currency-input>
                            </td>
                            <td class="_number">
                                {{parameters.previousPeriodInvestmentAnnualPercentageRate * 100 | number :'1.2'}} %
                            </td>
                            <td>
                                <kiwi-percentage-input [(ngModel)]="decision.investmentAnnualPercentageRate"
                                                       [disabled]="decisionsReadonly || !isAnimator"
                                                       name="investmentAnnualPercentageRate"
                                                       (change)="onValueUpdate()">
                                </kiwi-percentage-input>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </fieldset>
            </form>
        </div>
        <div class="cell xsmall-24 xlarge-8 xxlarge-10 decisionImg">
            <div class="decisionImg-item _financial"></div>
        </div>
    </div>
</kiwi-decision-content>
